<div class="modal-header">
    <h4 class="modal-title pull-left">{{conditionalDelayBlockData['title']}}</h4>
</div>
<div class="modal-body cs-common-ui">
    <form class="no-form-style" *ngIf="form" [formGroup]="form" novalidate>
        <div class="cs-d-flex flex-column">
            <div class="cs-helper-section bg-white cs-border cs-border--bottom">
                <div class="cs-help-text-color p--15">{{conditionalDelayBlockData['description']}}</div>
            </div>
            <app-conditional-edge2
                *ngIf="isConditional"
                [dagSourceModel]="dagSourceModel"
                [blockObject]="blockObject"
                [conditionalColName]="conditionalColName"
                [form]="form">
            </app-conditional-edge2>
            <div class="cs-flex-1">
                <div class="cs-block-widget--form cs-d-flex flex-column">
                    <div class="cs-block-widget--form-control">
                        <label class="control-label required_field mr-auto">{{conditionalDelayBlockData['inputLabelText']}}:</label>
                        <div class="cs-d-flex">
                            <ng-container [ngSwitch]="form.get('unit').value">
                                <select *ngSwitchCase="'Minutes'" class="full-width-select mr-10" formControlName="interval">
                                    <option *ngFor="let interval of minutesInterval" value="{{interval}}">{{interval}}</option>
                                </select>
                                <select *ngSwitchCase="'Hours'" class="full-width-select mr-10" formControlName="interval">
                                    <option *ngFor="let interval of hoursInterval" value="{{interval}}">{{interval}}</option>
                                </select>
                                <select *ngSwitchCase="'Days'" class="full-width-select mr-10" formControlName="interval">
                                    <option *ngFor="let interval of daysInterval" value="{{interval}}">{{interval}}</option>
                                </select>
                                <select *ngSwitchCase="'months'" class="full-width-select mr-10" formControlName="interval">
                                    <option *ngFor="let interval of monthsInterval" value="{{interval}}">{{interval}}</option>
                                </select>
                            </ng-container>
                            <select class="full-width-select" formControlName="unit" (change)="onChangeUnit($event)">
                                <option *ngFor="let unit of units" value="{{unit}}">{{unit}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="cs-block-widget--form-control">
                        <label class="control-label required_field mr-auto">Condition:</label>
                        <select [attr.disabled]="isReadOnlyMode ? '' : null" class="full-width-select mr-10" formControlName="event_method">
                            <option value="pass on before">Before</option>
                            <option value="pass on after">After</option>
                        </select>
                    </div>
                    <div class="cs-block-widget--form-control">
                        <label class="control-label required_field mr-auto">Select field:</label>
                        <select class="full-width-select2 cs-select2-wfe default-input-height"
                            formControlName="col_name"
                            (onChange)="onChangeField($event)"
                            csSelect2
                            [select2Config]="{}">
                            <option value="" translate>Please.Choose</option>
                            <option *ngFor="let field of fields" [value]="field.col_name">{{field.text}}</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>
<div class="modal-footer">
    <ng-container *ngIf="form else footerSection">
        <button *ngIf="showDeleteBtn" class="btn btn-danger btn-medium float-left" (click)="remove()" type="button">Delete </button>
        <button class="btn btn-link" (click)="closeModal()">Cancel</button>
        <button type="submit" class="btn btn-primary" [disabled]="!form.valid || isFormSubmitted" (click)="save()">
            <span *ngIf="!isFormSubmitted" translate>Save</span>
            <span *ngIf="isFormSubmitted" translate>Saving</span>
        </button>
    </ng-container>
</div>

<ng-template #footerSection>
    <button class="btn btn-link" [disabled]="true">Cancel</button>
    <button type="submit" class="btn btn-primary" [disabled]="true">
        <span translate>Save</span>
    </button>
</ng-template>
